import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDate } from '../../lib/hooks/useDate';
import type { Entry } from '../../types/cv';

/**
 * Renders an entry's date range.
 *
 * `entry.period` wins when present — a literal like "2019–2023" reads better
 * than "01/2019 – 01/2023" wherever the month is noise rather than signal.
 */
export const Period: FC<{ entry: Entry }> = ({ entry }) => {
  const { t } = useTranslation();
  const start = useDate(entry.startDate);
  const end = useDate(entry.endDate ?? entry.releaseDate ?? entry.date);

  if (entry.period) return <span className="cv-period">{entry.period}</span>;

  if (!start) return end ? <span className="cv-period">{end}</span> : null;

  return (
    <span className="cv-period">
      {start} – {end || t('common.present', 'Present')}
    </span>
  );
};

export default Period;
